export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";

export const AUTH_APIS = {
  LOGIN: "/distributor/login",
  LOGOUT: "/distributor/logout",
  RESET_PASSWORD: "/distributor/resetPasswordUser",
  CHANGE_PASSWORD: "/distributor/changePassword",
};

export const APP_API = {
  GET_SLP_MEMBERS: "/distributor/listSlpMembers",
  ADDEDIT_SLP_MEMBER: "/distributor/addEditSlpMembers",
  GET_RETAILERS: "/distributor/retailers",
  EDIT_RETAILERS: "/distributor/editRetailers",
  GET_MATERIALS: "/distributor/listMaterials",
  GET_PLANTS: "/distributor/listPlants",
  GET_STORAGE_LOCATIONS: "/distributor/listStorageLocations",
  ACCEPT_PURCHASE: "/distributor/acceptPurchase",
  ACCEPT_RETURN_PURCHASE: "/distributor/acceptReturnPurchase",
  REJECT_RETURN_PURCHASE: "/distributor/rejectReturnPurchase",
  ACCEPT_LIST_PUNCHED_ORDERS: "/distributor/acceptPunchedOrder",
  REJECT_LIST_PUNCHED_ORDERS: "/distributor/rejectPunchedOrder",
  REJECT_PURCHASE: "/distributor/rejectPurchase",
  GET_SECONDARY_SALES: "/distributor/secondarySales",
  PURCHASE_LIST : "/distributor/purchaseList",
  RETURN_PURCHASE_LIST : "/distributor/returnPurchaseList",
  GET_INVENTORY: "/distributor/listInventory",
  GET_INVENTORY_LEDGER: "/distributor/listInventoryLedger",
  GET_PUNCH_ORDERS: "/distributor/listPunchedOrders",
  GET_SALES_ORDER: "/distributor/listRetailerSalesOrders",
  GET_BOTREE_INVOICE: "/distributor/botreeInvoices",
  GET_PRICE_DIFFERENCE_REPORT: "/distributor/priceDifferenceReport",
  EDIT_ORDER_QUANTITY: "/distributor/editOrderQuantity",
  ADD_NEW_ORDER: "/distributor/addNewOrder",
  GET_QUANTITY_DETAILS: "/distributor/listDateWiseMaterialLogs",
  GENERATE_INVOICE: "/distributor/generateInvoice",
  GENERATE_E_INVOICE: "/distributor/generateEInvoice",
  GENERATE_RETURN_E_INVOICE: "/distributor/returnEInvoice",
  CANCEL_EWAY_BILL_INVOICE: "/distributor/cancelEwayBillInvoice",
  GENERATE_MULTIPLE_E_INVOICE: "/distributor/generateMultipleEInvoice",
  LIST_E_INVOICES_BILLS: "/distributor/listEBilledOrders",
  CANCEL_INVOICE: "/distributor/cancelInvoice",
  SEND_TO_BOTREE: "/distributor/sendInvoiceToBotree",
  RETURN_INVOICE: "/distributor/returnInvoice",
  REVERSE_BACK_RETURN_INVOICE: "/distributor/reverseReturnInvoice",
  UPLOAD_QR: "/distributor/uploadQR",
  EDIT_PROFILE: "/distributor/editProfile",
  ADD_PAYMENT: "/distributor/addPayment",
  PENDING_PAYMENT_ORDERS: "/distributor/listPendingPaymentOrders",
  LIST_PAYMENT_HISTORY: "/distributor/listPaymentsLogs",
  LIST_RETAILER_TRANSACTION: "/distributor/listRetailerTransactions",
  EXPORT_FILE: "/distributor/exportFile",
  ADVANCE_PAYMENTS: "/distributor/advancePayment",
  EDIT_PAYMENTS_DETAILS: "/distributor/editTransactionDetails",
  DISTRIBUTOR_DASHBOARD: "/distributor/dashboard",
  EDIT_EWAY_EINVOICE_DETAILS: "/distributor/editEwayBillDetails",
  GET_QR_CODE_IMAGE : "/distributor/eInvoiceQrCode",
  EDIT_INVENTORY : "/distributor/editInventory",
  IMPORT_FILE : "/distributor/importFile",
  BULK_ORDER_UPLOAD : "/distributor/importBulkOrderFile",
  EDIT_APP_SETTINGS : "distributor/appSettings",
  GET_APP_SETTINGS : "/distributor/settings",
  DOWNLOAD_LEDGER : "/distributor/downloadTransactionPdf",

  // Debit/Credit Notes APIs
  SEARCH_INVOICE_FOR_NOTE: "/distributor/searchInvoiceForNote",
  CREATE_DEBIT_CREDIT_NOTE: "/distributor/createDebitCreditNote",
  GENERATE_NOTE_E_INVOICE: "/distributor/generateNoteEInvoice",
  GET_DEBIT_CREDIT_NOTES: "/distributor/getDebitCreditNotes",
  GET_DEBIT_CREDIT_NOTE_DETAIL: "/distributor/getDebitCreditNoteDetail",
  GET_NOTE_QR_CODE: "/distributor/getNoteQrCode",
};
